/**
 * Material Symbols Rounded. The font is loaded in index.html with
 * `display=block`, so a ligature never flashes as raw text.
 */

export interface IconProps {
  name: string;
  filled?: boolean;
  /** Optical size in px. */
  size?: number;
  weight?: 300 | 400 | 500 | 600 | 700;
  className?: string;
}

export function Icon({ name, filled = false, size = 24, weight = 400, className = "" }: IconProps) {
  return (
    <span
      aria-hidden="true"
      className={`msr ${className}`}
      style={{
        fontSize: size,
        width: size,
        height: size,
        fontVariationSettings: `"FILL" ${filled ? 1 : 0}, "wght" ${weight}, "GRAD" 0, "opsz" ${size}`,
      }}
    >
      {name}
    </span>
  );
}
